import React from "react";
import Fonts from "../../../../Config/Fonts";
import { productCategoryTableCellHeader } from "../../../../Constants/MockData";
import Colors from "../../../../theme/Colors";

const ProductCategoryTableHeader = () => {
  return (
    <thead>
      {productCategoryTableCellHeader?.map((tCell, index) => (
        <th
          key={index}
          style={{
            fontSize: 12,
            fontWeight: "500",
            fontFamily: Fonts.Poppins,
            color: Colors.white,
            position: "sticky",
            top: 0,
            textAlign: "center",
            padding: "12px 5px",
            border: "1px solid #E6E6E6",
            backgroundColor: Colors.adminPrimaryColor,
          }}
        >
          {tCell?.header}
        </th>
      ))}
    </thead>
  );
};

export default ProductCategoryTableHeader;
